import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const VisitorTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Generate or get visitor ID from localStorage
        let visitorId = localStorage.getItem('visitor_id');
        if (!visitorId) {
            visitorId = 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('visitor_id', visitorId);
        }

        // Generate session ID
        let sessionId = sessionStorage.getItem('session_id');
        if (!sessionId) {
            sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            sessionStorage.setItem('session_id', sessionId);
        }

        // Track page view
        const trackVisit = async () => {
            try {
                await axios.post(`${API_BASE_URL}/api/track-visit`, {
                    page_url: window.location.pathname,
                    referrer: document.referrer,
                    visitor_id: visitorId,
                    session_id: sessionId
                });
            } catch (error) {
                console.error('Track visit error:', error);
            }
        };

        trackVisit();
    }, [location]);

    return null;
};

export default VisitorTracker;